import React from "react";
import AboutHero from "./AboutComponents/AboutHero";
import MissionSection from "./AboutComponents/MissionSection";
import HistorySection from "./AboutComponents/HistorySection";
import TeamSection from "./AboutComponents/TeamSection";
import ValuesSection from "./AboutComponents/ValuesSection";

const About = () => {
  return (
    <main>
      <AboutHero />
      <MissionSection />
      <ValuesSection />
    </main>
  );
};

export default About;
